import filled from './filled';

export const CLONE_IDENTIFIER = '-_CLONE_IDENTIFIER_-';
export const CLONE_REGEXP = new RegExp(CLONE_IDENTIFIER);
export const COMBINED_IDENTIFIER = '-_COMBINED_IDENTIFIER_-';
export const COMBINED_REGEXP = new RegExp(COMBINED_IDENTIFIER);

export function combinedName(combined) {
  return combined?.combine.join(COMBINED_IDENTIFIER);
}

export function cloneName(name) {
  const split = name.split('[').map((i) => i.replace(']', ''));
  const index = split.findIndex((i) => String(i) === String(parseInt(i, 10)));

  if (index) {
    split[index] = CLONE_IDENTIFIER;
  }

  return fieldName(...split);
}

export default function fieldName(...args) {
  const list = args.filter((i) => filled(i));
  const first = list.shift();

  if (list.length) {
    return `${first}[${list.join('][')}]`;
  }

  return first;
}

export function groupName(group) {
  return (typeof group === 'string' ? group : group.key || `${group.title}: ${group.subtitle}`);
}
